/**
 * Created by frank.law on 11/14/17.
 */
import React from 'react';
import '../../css/login.css';
import logo from '../../assets/logo.svg';
import PropTypes from "prop-types";
import {connect} from 'react-redux';

class Logo extends React.Component {

    render() {
        const {appLogo, appName} = this.props;
        const logoSrc = appLogo ? appLogo : logo;

        return (
            <div className="logo-container">
                <img src={logoSrc} className="logo" alt="logo" />
                <div className="app-name">
                    {appName}
                </div>
            </div>
        );
    }
}

Logo.propTypes = {
    appLogo: PropTypes.string,
    appName: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        appLogo: state.login.appLogo,
        appName: state.login.appName
    }
};

export default connect(mapStateToProps)(Logo);
